function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var animateValues = function animateValues(values, duration, options) {
  // Linear interpolation
  var lerp = function lerp(source, target, amount) {
    return source + amount * (target - source);
  }; // Validation methods


  var checkNum = function checkNum(n) {
    return typeof n === 'number' ? n : null;
  };

  var checkFunc = function checkFunc(f) {
    return typeof f === 'function' ? f : function (_) {
      return _;
    };
  }; // Ensure methods


  var onComplete = checkFunc(options.onComplete);
  var onUpdate = checkFunc(options.onUpdate);
  var ease = checkFunc(options.ease); // Animation start time

  var start = Date.now(); // Create a map <key: [from, to]>

  var animationMap = Object.keys(values).reduce(function (map, key) {
    var _from = checkNum(values[key]);

    var _to = checkNum(options[key]);

    if (_from !== null && _to !== null) map[key] = [_from, _to];
    return map;
  }, {}); // List of animating values

  var keys = Object.keys(animationMap); // Create & run animation function

  var animation = function animation() {
    var now = Date.now();
    var t = duration > 0 ? (now - start) / duration : 1; // Update all values using 't'

    keys.forEach(function (key) {
      // If both 'from' and 'to' are numbers: animate!
      var _animationMap$key = _slicedToArray(animationMap[key], 2),
          _from = _animationMap$key[0],
          _to = _animationMap$key[1];

      var progress = ease(t, _from, _to, duration); // Update value

      values[key] = lerp(_from, _to, progress);
    }); // If complete...

    if (t >= 1) {
      // Final update for all keys
      keys.forEach(function (key) {
        return values[key] = options[key];
      });
      onUpdate(values);
      onComplete(values);
    } else {
      // Run update callback and loop until finished
      onUpdate(values);
      requestAnimationFrame(animation);
    }
  };

  animation();
};

export default animateValues;